import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'marketplace-report-template',
    templateUrl: './report-template.component.html',
    styleUrls: ['./report-template.component.scss'],
    standalone: false
})
export class ReportTemplateComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
